import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@one-thd/sui-atomic-components';
import { Store } from '@one-thd/sui-icons';
import { getAvailabilitySummary } from './used-equipment-helper';

export function UsedEquipmentAvailability({ item }) {
  const { availableCount, unavailableCount, isAvailable } = getAvailabilitySummary(item);
  const storeLabel = item?.StoreData?.name ? `At ${item.StoreData.name}:` : 'At Your Store:';
  const unavailableMessage = [
    'This unit is currently rented out and will be available for purchase/rent once it\'s back.',
    'Check back soon.'
  ].join(' ');

  if (!isAvailable) {
    return (
      <div className="sui-flex sui-items-start sui-gap-1">
        <Store className="sui-w-4 sui-h-4 sui-shrink-0" aria-hidden="true" />
        <Typography variant="body-sm" className="sui-leading-tight">
          <span className="sui-font-bold sui-text-primary">{storeLabel}</span>
          {' '}
          <span className="sui-text-danger">{unavailableCount} Unavailable.</span>
          {' '}
          <span className="sui-text-subtle">{unavailableMessage}</span>
        </Typography>
      </div>
    );
  }

  return (
    <div className="sui-flex sui-items-start sui-gap-1">
      <Store className="sui-w-4 sui-h-4 sui-shrink-0" aria-hidden="true" />
      <Typography variant="body-sm" className="sui-leading-tight">
        <span className="sui-font-bold sui-text-primary">{storeLabel}</span>
        {' '}
        <span className="sui-text-success">{availableCount} available,</span>
        {' '}
        <span className="sui-text-primary">not eligible for online order Pickup</span>
        {unavailableCount > 0 && (
          <>
            {' '}
            <span className="sui-text-subtle">({unavailableCount} unavailable)</span>
          </>
        )}
      </Typography>
    </div>
  );
}

UsedEquipmentAvailability.propTypes = {
  item: PropTypes.shape({
    StoreData: PropTypes.shape({
      name: PropTypes.string
    }),
    rawUnits: PropTypes.arrayOf(PropTypes.shape({
      statusCd: PropTypes.number
    }))
  }).isRequired
};

UsedEquipmentAvailability.defaultProps = {};
